import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export interface PermitRecord {
  Place: string;
  place_fips: string;
  year: string | number;
  population: number;
  bps_total_bldg: number;
  permits_per_1k: number;
  permits_growth?: number | null;
}

export function usePermitsPer1kData(place: string | null, placeFips: string | null) {
  const [data, setData] = useState<PermitRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!place || !placeFips) {
      setLoading(false);
      setData([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    supabase
      .from('acs_bps_metrics_permit_per_1k')
      .select('*')
      .eq('Place', place)
      .eq('place_fips', placeFips)
      .order('year', { ascending: true })
      .then(({ data: supabaseData, error: supabaseError }) => {
        if (supabaseError) {
          console.error('Error fetching permit data:', supabaseError);
          setError(supabaseError.message);
          setData([]);
        } else {
          setData(supabaseData || []);
          // Log the latest record for the selected city
          const latest = (supabaseData || []).slice(-1)[0];
          if (latest) {
            console.log(`Selected City: ${latest.Place}`);
            console.log(`  FIPS: ${latest.place_fips}`);
            console.log(`  Permits per 1k: ${latest.permits_per_1k?.toFixed(2)}`);
            console.log(`  Year: ${latest.year}`);
          }
        }
        setLoading(false);
      });
  }, [place, placeFips]);

  return { data, loading, error };
} 